import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CreativeTagExport from './CreativeTagExport';
import Mixpanel from '../shared/Mixpanel';

const GenerateTagsButton = ({
  AdMarkupService,
  FlashService,
  getCreatives,
  hideModal,
  modalOpen,
  showModal
}) => {
  const onClick = () => {
    showModal();
    Mixpanel.track('Opened 2.2 Export Modal');
  };
  return (
    <Fragment>
      <button
        className="btn btn-primary dsp-export pl1 pr1 mr1"
        onClick={onClick}
      >
        <i className="material-icons small-icon">file_download</i>
        Generate Tags
      </button>
      <CreativeTagExport
        getCreatives={getCreatives}
        hideModal={hideModal}
        modalOpen={modalOpen}
        AdMarkupService={AdMarkupService}
        FlashService={FlashService}
      />
    </Fragment>
  );
};

GenerateTagsButton.propTypes = {
  AdMarkupService: PropTypes.object.isRequired,
  FlashService: PropTypes.object.isRequired,
  getCreatives: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  showModal: PropTypes.func.isRequired
};

export default GenerateTagsButton;
